import Vue from "vue";
import Router from "vue-router";
import Hello from "@/components/Hello";
import Login from "@/components/login";
import Register from "@/components/register";
import About from "@/components/about";
// titulaires
import Titulaires from "@/components/titulaires";
import Titulaire from "@/components/titulaire";
import TitulairesNew from "@/components/titulairesNew";
import TitulairesEdit from "@/components/titulairesEdit";
// remplaçants
import Remplacants from "@/components/remplacants";
import Remplacant from "@/components/remplacant";
import RemplacantsNew from "@/components/remplacantsNew";
import RemplacantsEdit from "@/components/remplacantsEdit";
// contrats
import Contrats from "@/components/contrats/contrats";
import Contrat from "@/components/contrats/contrat";
// import ContratsPrint from '@/components/contratsPrint'
import ContratsNew from "@/components/contrats/contratsNew";
import ContratsEdit from "@/components/contrats/contratsEdit";
// gardes
import Gardes from "@/components/gardes";
import Garde from "@/components/garde";
import GardesEdit from "@/components/gardesEdit";
import GardesNew from "@/components/gardesNew";

// interimaires
import InterimaireNew from "@/components/interim/interimNew";
import Interimaires from "@/components/interim/interims";
import Interimaire from "@/components/interim/interim";
import InterimaireEdit from "@/components/interim/interimEdit";
// contrats d'intérim
import ContratsInterim from "@/components/contratsInterim/contrats";
import ContratsInterimNew from "@/components/contratsInterim/contratNew";
import ContratsInterimEdit from "@/components/contratsInterim/contratEdit";
// iades
import Iades from "@/components/iades/iades";
// users
import Users from "@/components/Users";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Hello",
      component: Hello
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      // path: '/ej7iUfV3ASXq9WwVrkChZO8RK57DET',
      path: "/register",
      name: "Register",
      component: Register,
      meta: {
        requireAdminAuth: true
      }
    },
    {
      path: "/about",
      name: "About",
      component: About,
      meta: {
        requireAuth: false
      }
    },
    {
      path: "/titulaires",
      name: "Titulaires",
      component: Titulaires,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/titulaires/new",
      name: "TitulairesNew",
      component: TitulairesNew,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/titulaires/:id",
      name: "Titulaire",
      component: Titulaire,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/titulaires/:id/edit",
      name: "TitulairesEdit",
      component: TitulairesEdit,
      meta: {
        requireAuth: true
      }
    },
    // remplaçants
    {
      path: "/remplacants",
      name: "Remplacants",
      component: Remplacants,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/remplacants/new",
      name: "RemplacantsNew",
      component: RemplacantsNew,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/remplacants/:id",
      name: "Remplacant",
      component: Remplacant,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/remplacants/:id/edit",
      name: "RemplacantsEdit",
      component: RemplacantsEdit,
      meta: {
        requireAuth: true
      }
    },
    // contrats
    {
      path: "/contrats",
      name: "Contrats",
      component: Contrats,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/contrats/new",
      name: "ContratsNew",
      component: ContratsNew,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/contrats/:id/edit",
      name: "ContratsEdit",
      component: ContratsEdit,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/contrats/:id",
      name: "Contrat",
      component: Contrat,
      meta: {
        requireAuth: true
      }
    },
    // gardes
    {
      path: "/gardes",
      name: "Gardes",
      component: Gardes,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/gardes/new",
      name: "GardesNew",
      component: GardesNew,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/gardes/:id",
      name: "Garde",
      component: Garde,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/gardes/:id/edit",
      name: "GardesEdit",
      component: GardesEdit,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/interimaires/:id",
      name: "Interimaire",
      component: Interimaire,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/interimaires",
      name: "Interimaires",
      component: Interimaires,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/interimaires/new",
      name: "InterimaireNew",
      component: InterimaireNew,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/interimaires/:id/edit",
      name: "InterimaireEdit",
      component: InterimaireEdit,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/contrats_interim",
      name: "ContratsInterim",
      component: ContratsInterim,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/contrats_interim/new",
      name: "ContratsInterimNew",
      component: ContratsInterimNew,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/contrats_interim/:id/edit",
      name: "ContratsInterimEdit",
      component: ContratsInterimEdit,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/iades",
      name: "Iades",
      component: Iades,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/users",
      name: "Users",
      component: Users,
      meta: {
        requireAuth: true
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js